import {
  installLogShipper,
  logDiagEnvironment,
} from "@diy-avatar/shared/log_shipper_browser";
import App from "./App.svelte";
import "./app.css";

const backendUrl =
  (import.meta.env.VITE_BACKEND_URL as string | undefined) ??
  "http://localhost:8085";
if (backendUrl) {
  installLogShipper({ backendUrl, source: "student" });
  // Snapshot device/environment diagnostics once the shipper is up. No-op
  // unless the effective level (learned via the loglevel poll) is debug+.
  try {
    logDiagEnvironment();
  } catch {
    /* never block app boot on diagnostics */
  }
}

const target = document.getElementById("app");
if (!target) {
  throw new Error("missing #app");
}

const app = new App({ target });

export default app;
